import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { base_url } from "../../utils/utils";

export const get_day_end_day_list = createAsyncThunk(
  "day_end_day_list",
  async (data) => {
    const userIdString = localStorage.getItem("userId");
    const userId = JSON.parse(userIdString)?.aid;
    const body = new FormData();
    body.append("action", "dayendlist");
    body.append("agencyid", userId);
    if (data?.verified) {
      body.append("date", data?.date);
    } else {
      body.append("type", "pending");
      body.append("fd", data?.fd);
      body.append("td", data?.td);
    }

    data?.selectLink.forEach((v, i) => {
      body.append("table_checkbox[]", v);
    });
    const response = await fetch(base_url + "reports/day_end_reports.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  },
);
export const get_day_summery_list = createAsyncThunk(
  "day_summery_list",
  async (data) => {
    const userIdString = localStorage.getItem("userId");
    const userId = JSON.parse(userIdString)?.aid;
    const body = new FormData();
    body.append("action", "day_summary");
    body.append("agencyid", userId);
    body.append("date", data?.date);
    data?.selectLink.forEach((v, i) => {
      body.append("table_checkbox[]", v);
    });
    const response = await fetch(base_url + "reports/day_summary.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  },
);

export const get_vehicle_tracking = createAsyncThunk(
  "vehicle_tracking",
  async (data) => {
    const userIdString = localStorage.getItem("userId");
    const userId = JSON.parse(userIdString)?.aid;
    const body = new FormData();
    body.append("action", "list");
    body.append("agencyid", userId);
    body.append("date", data?.date);
    body.append("page", data?.page);
    body.append("limit", data?.limit);

    const response = await fetch(base_url + "reports/vehicle_tracking.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  },
);

export const get_dayend_data = createAsyncThunk("dayend", async (data) => {
  const userIdString = localStorage.getItem("userId");
  const userId = JSON.parse(userIdString)?.aid;
  const body = new FormData();
  body.append("action", "list");
  body.append("agencyid", userId);
  body.append("date", data?.date);
  body.append("page", data?.page);
  body.append("limit", data?.limit);

  const response = await fetch(base_url + "reports/dayend.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  return res;
});

export const get_day_end_data = createAsyncThunk("dayend2", async (data) => {
  const userIdString = localStorage.getItem("userId");
  const userId = JSON.parse(userIdString)?.aid;
  const body = new FormData();
  // body.append("action", "list");
  body.append("agencyid", userId);
  body.append("date", data?.date || "");

  const response = await fetch(base_url + "reports/day_end.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  return res;
});

const initialState = {
  day_summery_date: "",
  day_end_date_list: [],
  day_end_date_loading: false,
  last_transaction_verification_date: "",
  day_summery_list: [],
  day_summery_loading: false,
  cylinder_stock_list: [],
  arb_stock_list: [],
  bank_transaction_day_list: [],
  cash_transaction_day_list: [],
  expencess_day_list: [],
  day_summery_pdf: "",
  day_summery_excel: "",
  vehicle_tracking_list: [],
  vehicle_tracking_loading: false,
  vehicle_tracking_count: 0,
  dayend_list: [],
  dayend_loading: false,
  dayend_count: 0,
  day_end_list: {},
  day_end_loading: false,
  day_end_count: 0,
};

const dayEndDateSlice = createSlice({
  name: "cylinder_purchase_data",
  initialState: initialState,
  extraReducers: (builder) => {
    // transition complete list

    builder
      .addCase(get_day_end_day_list.pending, (state, action) => {
        state.day_end_date_loading = true;
      })
      .addCase(get_day_end_day_list.fulfilled, (state, action) => {
        const data = action.payload;
        state.day_end_date_loading = false;

        // ✅ SAVE API DATE regardless of success status
        state.last_transaction_verification_date = data.day_end_date || "";

        if (data?.success) {
          state.day_end_date_list = data.datalist;
        } else {
          state.day_end_date_list = [];
        }
      })
      .addCase(get_day_end_day_list.rejected, (state, action) => {
        state.day_end_date_loading = false;
      });

    builder
      .addCase(get_vehicle_tracking.pending, (state, action) => {
        state.vehicle_tracking_loading = true;
        state.vehicle_tracking_count = 0;
      })
      .addCase(get_vehicle_tracking.fulfilled, (state, action) => {
        const data = action.payload;
        state.vehicle_tracking_loading = false;
        console.log(data);

        if (data?.success) {
          state.vehicle_tracking_list = data.data;
          state.vehicle_tracking_count = data.totalcount;
        } else {
          state.vehicle_tracking_list = [];
          state.vehicle_tracking_count = 0;
        }
      })
      .addCase(get_vehicle_tracking.rejected, (state, action) => {
        state.vehicle_tracking_loading = false;
      });

    builder
      .addCase(get_day_summery_list.pending, (state, action) => {
        state.day_summery_loading = true;
      })
      .addCase(get_day_summery_list.fulfilled, (state, action) => {
        const data = action.payload;
        state.day_summery_loading = false;

        if (data?.success) {
          state.day_summery_list = data.datalist;
          state.day_summery_date = data.date;
          state.day_summery_pdf = data?.pdf_file;
          state.day_summery_excel = data?.excel_file;
        } else {
          state.day_summery_list = [];
          state.day_summery_date = "";
          state.day_summery_pdf = "";
          state.day_summery_excel = "";
        }
      })
      .addCase(get_day_summery_list.rejected, (state, action) => {
        state.day_summery_loading = false;
      });

    builder
      .addCase(get_dayend_data.pending, (state, action) => {
        state.dayend_loading = true;
      })
      .addCase(get_dayend_data.fulfilled, (state, action) => {
        const data = action.payload;
        state.dayend_loading = false;

        if (data?.success) {
          state.dayend_list = data.data;
        } else {
          state.dayend_list = [];
        }
      })
      .addCase(get_dayend_data.rejected, (state, action) => {
        state.dayend_loading = false;
      });

    builder
      .addCase(get_day_end_data.pending, (state, action) => {
        state.day_end_loading = true;
      })
      .addCase(get_day_end_data.fulfilled, (state, action) => {
        const data = action.payload;
        state.day_end_loading = false;

        state.day_end_list = data;
      })
      .addCase(get_day_end_data.rejected, (state, action) => {
        state.day_end_loading = false;
      });
  },
});

export default dayEndDateSlice.reducer;
